<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="filter-container">
        <div class="filter-container-group">
            <div class="filter-container-title">{{ firstLevelTitle }}</div>
            <div class="filter-group-options">
                @for (option of firstLevelOptions; track option) {
                    <div class="filter-group-option">
                        <p-radioButton
                            styleClass="radio-style"
                            [inputId]="'level_1_' + option.id"
                            formControlName="firstLevelOption"
                            [value]="option"
                        ></p-radioButton>
                        <label
                            [for]="'level_1_' + option.id"
                            class="label-btn radio"
                            [ngClass]="{
                                'selected-button': firstLevelFormControl.value?.value === option.value,
                                'unselected-button': firstLevelFormControl.value?.value !== option.value
                            }"
                        >
                            {{ option.label }}
                        </label>
                    </div>
                }
            </div>
        </div>

        @if (selectedFirstLevel) {
            <div class="filter-container-group">
                <div class="filter-container-title">{{ selectedFirstLevel.label }}</div>
                <div class="filter-group-options">
                    @for (option of secondLevelOptions; track option) {
                        <div class="filter-group-option">
                            <p-checkbox
                                [inputId]="'level_2_' + option.id"
                                formControlName="secondLevelOptions"
                                [value]="option"
                            ></p-checkbox>
                            <label [for]="'level_2_' + option.id" class="label-btn">
                                {{ option.label }}
                            </label>
                        </div>
                    }
                </div>
            </div>
        }

        @if (selectedSecondLevelOptions.length > 0) {
            <div class="filter-container-group">
                <div class="filter-container-title">{{ 'EstateTypes' | localize }}</div>
                <div class="filter-container-group">
                    <div class="filter-group-options">
                        @for (option of estateTypesOptions; track option; let i = $index) {
                            <div class="filter-group-option">
                                <p-checkbox
                                    [inputId]="'level_3_' + option.id"
                                    formControlName="estateTypesOptions"
                                    [value]="option"
                                ></p-checkbox>
                                <label [for]="'level_3_' + option.id" class="label-btn">
                                    {{ option.label }}
                                </label>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
    </div>
</form>
